import { axiosClient } from '../../../library/Service/axiosClient';
import PageConfigContact from './PageConfigContact.json';

class ContactLisingService {
    static pageLoader(params: any): Promise<any> {
            const state: any = {};
            const searchCriteria = ContactLisingService.getDefaultSearchCriteria();
    
            return Promise.all([
                this.getPageConfig(),
                this.search(searchCriteria, params.id,params.pageName),
            ]).then((values) => {
                console.log("values[1].data",values[1].data)
                state.formConfig = values[0];
                state.data = {
                    contactList: values[1].data ?? [],
                    id : params.id,
                    groupId : params.groupId, 
                    searchCriteria: { ...searchCriteria},
                    //filterDomains: values[2].data,
                };
                state.routeInfo = params;
                state.internal = { gridState: {} };
                return Promise.resolve(state);
            });
        }
    
    
    // static search(id:any) {
    //     return axiosClient().get(`${process.env.REACT_APP_ADMIN_API_SERVER}/institute/${id}/contacts`);
    // }
     static search(searchCriteria: any, id: string, pageName : string): any {
        const sanitized = ContactLisingService.sanitizeSearchCriteria(searchCriteria);
        const payload = {
            ...sanitized,
            instituteId: id  
        };
        return axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/institute/contacts`, payload);
        // return axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/${config.SEARCH_API}`, payload);
    }

    static getPageConfig() {
        return Promise.resolve(PageConfigContact);
    }

    static sanitizeSearchCriteria(searchCriteria: any) {
        searchCriteria = { ...searchCriteria};
        if (['YES', 'NO'].includes(searchCriteria['withLoginAccount'])) {
            searchCriteria['withLoginAccount'] = searchCriteria['withLoginAccount'] === 'YES' ? 'ACTIVE' : 'INACTIVE';
        }

        if (['YES', 'NO'].includes(searchCriteria['topManagement'])) {
            searchCriteria['topManagement'] = searchCriteria['topManagement'] === 'YES' ? 1 : 0;
        }

        if (['YES', 'NO'].includes(searchCriteria['spoc'])) {
            searchCriteria['spoc'] = searchCriteria['spoc'] === 'YES' ? 1 : 0;
        }

         if (['YES', 'NO'].includes(searchCriteria['showOnValidationScreen'])) {
            searchCriteria['showOnValidationScreen'] = searchCriteria['showOnValidationScreen'] === 'YES' ? 1 : 0;
        }
        
        return searchCriteria;
    }

    static getDefaultSearchCriteria(): any {
        return {
            topManagement : [],
            spoc : [],
            withLoginAccount : [],
            showOnValidationScreen : []
        };
    }
}

export default ContactLisingService;
